import { render } from "./richtextshow.vue?vue&type=template&id=8e447480&scoped=true"
import script from "./richtextshow.vue?vue&type=script&lang=js"
export * from "./richtextshow.vue?vue&type=script&lang=js"

import "./richtextshow.vue?vue&type=style&index=0&id=8e447480&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e447480"]])

export default __exports__